// <tea-product> — tea PDP: gallery, quantity, add (Pre-order aware), "Add a Cha Maker" add-on, sticky bar,
// ingredients drawer, STOQ notify for sold-out teas.
const R = { fmt: document.documentElement.dataset.moneyFormat };
class TeaProduct extends HTMLElement {
  connectedCallback() {
    this.qty = 1; this.img = 0; this.variant = +this.dataset.variant;
    this.input = this.querySelector('[data-variant-input]'); this.form = this.querySelector('[data-product-form]');
    this.add = this.querySelector('[data-add]'); this.qtyEl = this.querySelector('[data-qty]');
    this.addEventListener('click', (e) => {
      const th = e.target.closest('.zp-th'); if (th) return this.go(+th.dataset.go);
      const st = e.target.closest('.zp-gbtn'); if (st) return this.go(this.img + +st.dataset.step);
      if (e.target.closest('[data-qty-inc]')) return this.setQty(this.qty + 1);
      if (e.target.closest('[data-qty-dec]')) return this.setQty(this.qty - 1);
      if (e.target.closest('[data-maker-add]')) return this.addMaker(e.target.closest('[data-maker-add]'));
      const dOpen = e.target.closest('[data-drawer-open]'); if (dOpen) return this.drawer(true, dOpen);
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-veil]')) return this.drawer(false);
      if (e.target.closest('[data-notify]')) return this.notify();
      if (e.target.closest('[data-bar-add]')) this.addTea();
    });
    this.form.addEventListener('submit', (e) => { e.preventDefault(); this.addTea(); });
    this.querySelector('[data-var]')?.addEventListener('change', (e) => {
      this.variant = +e.target.value; this.input.value = this.variant; const u = new URL(location.href); u.searchParams.set('variant', this.variant); history.replaceState(null, '', u);
      // jump the gallery to the chosen variant's own image (no page scroll on the phone swipe gallery)
      const mid = e.target.selectedOptions[0]?.dataset.media; const fig = mid && this.querySelector(`.zp-gi[data-media="${mid}"]`);
      if (fig) this.go(+fig.dataset.i, true);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.drawerOpen) this.drawer(false); });
    const bar = this.querySelector('[data-bar]');
    if (bar && 'IntersectionObserver' in window) {
      this.io = new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', String(!on));
        const b = bar.querySelector('[data-bar-add]'); if (b) b.tabIndex = on ? 0 : -1;
        document.documentElement.classList.toggle('bar-on', on);
      }); this.io.observe(this.querySelector('.tq-buy'));
    }
    this.gal = this.querySelector('.zp-gal');
    this.img = +(this.querySelector('.zp-gi.on')?.dataset.i || 0);
    if (this.img && getComputedStyle(this.gal).overflowX === 'auto') requestAnimationFrame(() => this.go(this.img, true));
  }
  disconnectedCallback() { this.io?.disconnect(); document.documentElement.classList.remove('bar-on'); }
  setQty(n) { this.qty = Math.max(1, Math.min(99, n)); this.qtyEl.textContent = this.qty; this.querySelector('[data-qty-dec]').disabled = this.qty <= 1; }
  go(i, fromVariant = false) {
    const items = [...this.querySelectorAll('.zp-gi')]; if (!items.length) return;
    i = (i + items.length) % items.length; this.img = i;
    if (getComputedStyle(this.gal).overflowX === 'auto') {
      if (fromVariant) this.gal.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      else items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      return;
    }
    items.forEach((it, k) => { it.classList.toggle('on', k === i); it.setAttribute('aria-hidden', String(k !== i)); });
    this.querySelectorAll('.zp-th').forEach((t, k) => { t.classList.toggle('on', k === i); });
    const c = this.querySelector('[data-gcur]'); if (c) c.textContent = String(i + 1).padStart(2, '0');
  }
  error(m) { const e = this.querySelector('[data-error]'); if (e) { e.textContent = m; e.hidden = !m; } }
  async addTea() {
    if (!window.ClCart) return this.form.submit();
    this.add.setAttribute('aria-busy', 'true');
    try {
      await window.ClCart.add([{ id: this.variant, quantity: this.qty }]); this.error('');
      const s = this.add.querySelector('.roll > span'); if (s) { s.textContent = this.add.dataset.added; s.dataset.t = this.add.dataset.added; clearTimeout(this.t); this.t = setTimeout(() => { s.textContent = this.add.dataset.verb; s.dataset.t = this.add.dataset.verb; }, 2400); }
    } catch (e) { this.error(e.message); } finally { this.add.removeAttribute('aria-busy'); }
  }
  async addMaker(btn) {
    const id = +this.dataset.maker; if (!id || !window.ClCart) return;
    const card = btn.closest('.tq-maker'); btn.setAttribute('aria-busy', 'true');
    try { await window.ClCart.add([{ id, quantity: 1 }]); card.classList.add('added'); } catch (e) { this.error(e.message); } finally { btn.removeAttribute('aria-busy'); }
  }
  notify() { const rr = window._RestockRocket, cfg = window._RestockRocketConfig; if (rr?.openModal && cfg?.product) rr.openModal(cfg.product, this.variant); else this.error(window.ClStrings?.notify_unavailable || 'Notifications are unavailable right now. Please email cs@elaiksir.com.'); }
  drawer(open, trigger) {
    const d = this.querySelector('[data-drawer]'), v = this.querySelector('[data-drawer-veil]'); if (!d) return;
    d.classList.toggle('open', open); v.classList.toggle('open', open); d.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('lock', open); this.drawerOpen = open;
    if (open) { this.prev = trigger; setTimeout(() => d.querySelector('.sq')?.focus({ preventScroll: true }), 50); } else this.prev?.focus?.({ preventScroll: true });
  }
}
if (!customElements.get('tea-product')) customElements.define('tea-product', TeaProduct);
